export function initSliderProduct($) {
  /* ========================================================================= *\
  **  === Slider                                                               *| 
  \* ========================================================================= */
  

  $('.slider-product--slider').not('.slick-initialized').slick({
    // arrows: false,
    infinite: true,
    autoplay: true,
    // cssEase: 'ease-in-out',
    autoplaySpeed: 3000,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: $('.slider-product--arrows .next'),
    prevArrow: $('.slider-product--arrows .prev'),
    responsive: [
      {
        breakpoint: 1700,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false
        }
      }
    ]
  });
  
}
